import { createSlice } from "@reduxjs/toolkit";

export const panierSlice = createSlice({ //reducers for both hours in global state
    name: 'panier',
    initialState:{},
    reducers: {
        setPanier: (currentState, action) => {
            return action.payload
        },
        modifPanier: (currentState, action) => {
            let cleanPanier = [...currentState];
            //le paylod est un indice du tableau et un tableau d'attributs {champ,value} à modifier dans le state sejour
            let champList = [...action.payload.champs];
            let cleanItem = cleanPanier[action.payload.index]
            champList.forEach(attribut=>{
                cleanItem[attribut.champ]=attribut.value;
            })

            cleanPanier[action.payload.index]=cleanItem;
            
            return cleanPanier
        },
        insertArticle:(currentState, action) => {
            let cleanPanier = [...currentState];
            cleanPanier.push(action.payload);
            
            return cleanPanier
        },
        deleteArticle:(currentState, action) => {
            let cleanPanier = [...currentState];
            
            let newList=cleanPanier.filter(article=>!(article.article_id===action.payload.id && article.taille_id===action.payload.taille));
            
            return newList
        },
        incrementArticleQty:(currentState, action) => {
            const newPanier = currentState.map((item) =>
            item.article_id===action.payload.id && item.taille_id===action.payload.taille
                ? { ...item,
                    qte : item.qte+1
                }
                : item
            )
            
            return newPanier 
        },
       decrementArticleQty:(currentState, action) => {
        const newPanier = currentState.map((item) =>
        item.article_id===action.payload.id && item.taille_id===action.payload.taille
            ? { ...item,
                qte : item.qte-1
            }
            : item
        )
        
        return newPanier 
        }
    }
});

 /* dispatch(panierSlice.actions.setPanier([
            {
                location_id: 0,
                article_id: 1,
                qte: 2,
                taille_id: 1
            },
            {
                location_id: 0,
                article_id: 2,
                qte: 1,
                taille_id: 5
            },
        ])) */